import React, { forwardRef } from 'react';
import MUIMenuList, {
  MenuListProps as MUIMenuListProps,
} from '@material-ui/core/MenuList';

interface MenuListProps extends MUIMenuListProps {}

const MenuList = forwardRef<HTMLUListElement, MenuListProps>((props, ref) => {
  return (
    <MUIMenuList {...props} ref={ref}>
      {props.children}
    </MUIMenuList>
  );
});

MenuList.displayName = 'MenuList';

export default MenuList;
